@if (successVisible()) {
  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
    <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
  </svg>
}

@if (errorVisible()) {
  <svg id="failure-animation" class="animated" xmlns="http://www.w3.org/2000/svg" width="200" height="200"
       viewBox="0 0 70 70">
    <circle id="failure-animation-circle" cx="35" cy="35" r="24" stroke-width="2" stroke-linecap="round"
            fill="transparent"/>
    <polyline class="failure-animation-check-line" stroke-width="2" points="25,25 45,45"
              fill="transparent"/>
    <polyline class="failure-animation-check-line" stroke-width="2" points="45,25 25,45"
              fill="transparent"/>
  </svg>
}
